/*eslint-disable no-undef */
import phina from 'phina.js'
import April from '../ALizard/April'

export default ()=>{

  /**
 * StoryScene
 */
phina.define("StoryScene", {
  superClass : "MyDisplayScene",
  init : function(param) {
    // var self = this;
    param=(param||{}).$safe(StoryScene.defaults);
    this.superInit({width:1000,height:600,scale:param.scale});

    this.code = [].concat(param.code);
    this.store = param.store;
    this.cur = 0;
    this.playing = false;
    this.bg1 = param.bg ?phina.display.Sprite(param.bg)
    .setPosition(500,300)
    .addChildTo(this) :null;
    this.bg2 = phina.display.DisplayElement({
    }).setPosition(500,300)
    .addChildTo(this)
    // bg3 weather用
    this.bg3 = phina.display.DisplayElement({
    }).setPosition(500,300)
    .addChildTo(this)
    this.front = phina.display.DisplayElement({
    }).setPosition(500,300)
    .addChildTo(this)
    // front2 black-out用
    this.front2 = phina.display.DisplayElement({
    }).setPosition(500,300)
    .addChildTo(this)
    // front3
    this.front3 = phina.display.DisplayElement({
    }).setPosition(500,300)
    .addChildTo(this)

    this.recorder = null;
    this.store.dispatch('setRecorder', null);

    if(param.code.length){
      this.onenter = function(){
        // this.recorder = phina.graphics.CanvasRecorder(this.canvas)
        // this.recorder.start(5, 60000);
        this.play();
      };
    }
  },
  play: function(){
    this.playing = true;
    if(this.cur >= this.code.length){
      // this.app.popScene(); return;
      //TODO CORS対策
      // this.recorder.stop();
      // this.recorder.on('finished', ()=>{
      //   this.store.dispatch('setRecorder', this.recorder.objectURL);
      // })
      return;
    }
    var data = this.code[this.cur++];
    this.store && this.store.dispatch('nextCode');
    if(April.call(data.call, {scene: this}.$extend(data.arguments))){
      if(this.playing){
        this.play();
      }else{
        this.playing = true;
      }
    }else{
      this.playing = false;
    }
  },
  next: function(delay){
    this.tweener.clear()
      .wait(delay || 10000)
      .call(()=>{this.play()})
  },
  _static:{
    defaults:{
      code:[],
      bg:null,
      store:null
    }
  }
});

}